import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import http from "../services/http";
import ReactPaginate from "react-paginate";
import dots from "../assets/images/dots.svg";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownRight from "./DropdownRight";
import Nav from "./Nav";
import shareIcon from "../assets/images/arrow.png";
import folder from "../assets/images/folder.png";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { AiFillEye } from "react-icons/ai";


function Applicants() {
  const navigate = useNavigate();

  const handleCloses = () => setShows(false);
  const [showModals, setShows] = useState(false);
  const [selectedId, setSelectedId] = useState(0);

  const [key, setKey] = useState("home");
  const token = localStorage.getItem("xAuthToken");
  const [analyst, setAnalyst] = useState([]);
  const [analystForModal, setAnalystForModal] = useState([]);
  const [available, setAvailable] = useState([]);
  const [unavailable, setUnAvailable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggle, setToggle] = useState(true);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState({});
  const [showShareModal, setShowShareModal] = useState(false);
  const [checkedEmails, setCheckedEmails] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const handleShareClose = () => setShowShareModal(false);
  const [showSelectAnalystsModal, setShowSelectAnalystsModal] = useState(false);
  const [selectedAnalystId, setSelectedAnalystId] = useState(null);
  const [analystList, setAnalystList] = useState([]);
  const [chosenAnalysts, setChosenAnalysts] = useState([]);
  const [selectedApplicantName, setSelectedApplicantName] = useState('');

  useEffect(() => {
    Analyst();
    AnalystForModal();
  }, []);

  const Analyst = async () => {
    setLoading(true);

    http
      .get(`public/admin/analyst/applicants?token=${token}`)
      .then((res) => {
        // console.log("applicants----->", res.data);
        setAnalyst(res.data);
        setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const AnalystForModal = async () => {
    setLoading(true);
    http
      .get(`public/admin/analyst?token=${token}`)
      .then((res) => {
        // console.log("analyst----->", res.data);
        setAnalystForModal(res.data);
        setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "home":
        setLoading(true);
        http
          .get(`public/admin/analyst/applicants?token=${token}`)
          .then((res) => {
            // console.log("applicants", res.data);
            setAnalyst(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log("error==>", error);
          });

        break;

      case "Completed":
        setLoading(true);
        http
          .get(`public/admin/analyst/cancelled?token=${token}`)
          .then((res) => {
            // console.log("cancelled=====>", res.data);
            setUnAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;

      default:
        setLoading(true);
        http
          .get(`public/admin/analyst/pending?token=${token}`)
          .then((res) => {
            // console.log("pending=====>", res.data);
            setAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log("error==>", error);
            setLoading(false);
          });
        break;
    }
  };

  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 7;
  const usersPerPageModal = 5;
  const pagesVisited = pageNumber * usersPerPage;
  const pagesVisitedModal = pageNumber * usersPerPageModal;
  const pageCountAnalyst = Math.ceil(analyst.length / usersPerPage);
  const pageCountAnalystModal = Math.ceil(analyst.length / usersPerPageModal);
  const pageCountAvailable = Math.ceil(available.length / usersPerPage);
  const pageCountUnavailable = Math.ceil(unavailable.length / usersPerPage);
  const listAnalyst = analyst.length;
  const listAvailable = available.length;
  const listUnavailable = unavailable.length;
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const openBucketModal = (applicant) => {
    setSelectedApplicant(applicant);
    setShows(true);
  };

  const openShareModal = () => {
    setShowShareModal(true);
  };

  const handleCheckboxChange = (email) => {
    setCheckedEmails((prevCheckedEmails) =>
      prevCheckedEmails.includes(email)
        ? prevCheckedEmails.filter((e) => e !== email)
        : [...prevCheckedEmails, email]
    );
  };

  const handleHeaderCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedEmails([]);
    } else {
      const emails = analystForModal.map((item) => item.email);
      setCheckedEmails((prev) => [...new Set([...prev, ...emails])]);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleSendClick = async () => {
    if (checkedEmails.length === 0) {
      showToast("error", "Please select at least one email.");
      // alert("Please select at least one email.");
      return;
    }

    try {
      const response = await http.post(
        `public/admin/analyst/share/${selectedApplicant.id}?token=${token}`,
        {
          recievers: checkedEmails,
        }
      );

      if (response.status === 200) {
        showToast("success", "Emails sent successfully!");
        // alert("Emails sent successfully!");
      }
      setShowShareModal(false);
    } catch (error) {
      console.error("Error sending emails:", error);
      showToast("error", "Failed to send emails. Please try again later.");
      // alert("Failed to send emails. Please try again later.");
    }
  };

  const handleReject = async (id) => {
    setUploadSpin(true);
    try {
      http
        .put(`public/admin/analyst/cancel?token=${token}`, {
          id: id,
          is_cancelled: 1,
          is_approved: 0,
        })
        .then((res) => {
          showToast("success", "Record rejected successfully!");
          // alert("Record rejected successfully!");
        });
    } catch (error) {
      console.error("Error rejecting record:", error);
      showToast("error", "Failed to reject record. Please try again later.");
      // alert("Failed to reject record. Please try again later.");
    } finally {
      setUploadSpin(false);
      handleCloses();
    }
  };

  const handleApprove = async (id) => {
    setUploadSpin(true);
    try {
      http
        .put(`public/admin/analyst/approve?token=${token}`, {
          id: id,
          is_approved: 1,
          is_cancelled: 0,
        })
        .then((res) => {
          showToast("success", "Record approved successfully!");
          // alert("Record approved successfully!");
        });
    } catch (error) {
      console.error("Error approving record:", error);
      showToast("error", "Failed to approve record. Please try again later.");
      // alert("Failed to approve record. Please try again later.");
    } finally {
      setUploadSpin(false);
      handleCloses();
    }
  };

  const handleStatusChange = async (itemId, newStatus) => {
    setUploadSpin(true);
    try {
      http
        .put(`api/admin/analyst/edit/applicant-profile-status/${itemId}?token=${token}`, {
         actionStatus:newStatus
        })
        .then((res) => {
          showToast("success", res.data.message);
          Analyst();
        });
    } catch (error) {
      console.error("Error approving record:", error);
      showToast("error", "Failed to update record. Please try again later.");
    } finally {
      setUploadSpin(false);
      handleCloses();
    }
  };


  const openSelectAnalystsModal = (item) => {
    setSelectedAnalystId(item.id);
    setSelectedApplicantName(item.firstname)
    fetchAnalystNames(); // Fetch analysts when modal opens
    setShowSelectAnalystsModal(true);
  };

  const fetchAnalystNames = async () => {
    try {
      http
        .get(`api/admin/analyst/analyst/approved-available/list?token=${token}`)
        .then((res) => {
          setAnalystList(res.data.getAnalystDetails); 
          setChosenAnalysts([]);
        })
        .catch((error) => {
          console.log("error==>", error);
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching analysts:", error);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setChosenAnalysts(analystList.map(analyst => analyst.id)); // Select all
    } else {
      setChosenAnalysts([]); // Deselect all
    }
  };

  const toggleAnalystSelection = (analystId) => {
    setChosenAnalysts(prevSelected => {
      const newSelection = prevSelected.includes(analystId)
        ? prevSelected.filter(id => id !== analystId) // Deselect
        : [...prevSelected, analystId]; // Select

      // If all analysts are selected, check Select All; otherwise, uncheck it
      if (newSelection.length === analystList.length) {
        document.getElementById("selectAllCheckbox").checked = true; // Check Select All
      } else {
        document.getElementById("selectAllCheckbox").checked = false; // Uncheck Select All
      }

      return newSelection;
    });
  };

  const onShareClick = () => {
    http
    .post(`api/admin/analyst/applicant-assign?token=${token}`, {
      selectedAnalystId: chosenAnalysts,
      applicant_id:selectedAnalystId
    })
    .then((res) => {
      showToast("success", res.data.message);
      setShowSelectAnalystsModal(false);
      setChosenAnalysts([]);
      setSelectedAnalystId(null);
      setSelectedApplicantName('')
    }).catch((error) => {
      showToast("error", error.response.data.message);
      setLoading(false);
    });
  };

  const capitalizeName = (name) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  return (
    <>
      <div className="wrapper">
        {toggle && <Nav />}
        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                {" "}
                <h1> Analyst Applicants</h1>
              </div>
              <DropdownRight />
            </div>
          </header>
          <div className="dashbord_content">
            <div className="analysts-wraper-head">
              <div className="personal_and_bank_info Analysts_tabs ">
                <Tabs
                  activeKey={key}
                  onSelect={(k) => InProgress(k)}
                  style={{
                    alignItems: "center",
                    width: 470,
                    borderRadius: 5,
                    marginTop: 25,
                    backgroundColor: "#f6f6f6",
                    padding: 10,
                  }}
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3 nav nav-pills border-bottom-0"
                >
                  <Tab eventKey="home" title="All" style={{ marginTop: 20 }}>
                    <div className="table_vedio_upload dashbord_table mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Applicant ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Folder Link
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="text-center">
                              Share
                            </th>
                            <th scope="col" className="text-center">
                              View Status
                            </th>
                            {/* <th scope="col" className="  ">
                              {" "}
                            </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 250,
                                backgroundColor: "#ffffffc2",
                                marginLeft: 580,
                                backgroundBlendMode: "overlay",
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="15%" />
                            </div>
                          ) : (
                            <>
                              {analyst
                                .slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                )
                                ?.map((item) => (
                                  <tr data-id={item.id}>
                                    {/* <td className="pl_25">{item.id} </td> */}
                                    <td>
                                      {" "}
                                      {item.firstname} {item.lastname}
                                    </td>
                                    <td className="email_ids">{item.email}</td>
                                    <td>
                                      <button
                                        className="link-button"
                                        onClick={() => openBucketModal(item)}
                                      >
                                        bucket
                                      </button>
                                    </td>

                                    <td>
                                      <div className="btn_wraper d-flex justify-content-center  ">
                                        <div className="btn_Subscribed">
                                          {" "}
                                          {/* <button
                                            type="button"
                                            className={
                                              "" +
                                              (item.is_cancelled === 0
                                                ? "them_btn_Pending"
                                                : "them_btn_Unsubscribed")
                                            }
                                          >
                                            {item.is_cancelled === 0
                                              ? "Pending"
                                              : "Cancelled"}
                                          </button>{" "} */}
                                              <select
                                                // className={
                                                //   item.is_cancelled === 0 ? "them_btn_Pending" : "them_btn_Unsubscribed"
                                                // }
                                                className={ item.is_approved === 1 ? 'them_btn_Subscribed' : item.is_cancelled === 1 ? "them_btn_Unsubscribed" : 'them_btn_Pending' }
                                                value={ item.is_approved === 1 ? 'approved' : item.is_cancelled === 1 ? "cancelled" : 'pending'}
                                                onChange={(e) => handleStatusChange(item.id, e.target.value)}
                                                style={{ 
                                                  textAlign: 'center',
                                                  padding: '5px',
                                                  // width: '150px' // Optional: fixed width

                                                }}
                                              >
                                                <option value="pending" style={{color:"grey",backgroundColor:"rgb(226, 224, 224)"}}>Pending</option>
                                                <option value="approved" style={{color:"#00c90d",backgroundColor:"#ebfbec"}}>Approved</option>
                                                <option value="cancelled" style={{color:"#ff4e00",backgroundColor:"#ffeae1"}}>Cancelled</option>
                                              </select>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <img
                                        src={shareIcon}
                                        alt="Share"
                                        className="share_icon_img"
                                        onClick={() => openSelectAnalystsModal(item)}
                                      />
                                      {/* <button
                                        className="btn btn-share"
                                        onClick={() => openSelectAnalystsModal(item)}
                                      >
                                        Share to Analyst
                                      </button> */}
                                    </td>
                                    <td className="text-center">
                                      <button
                                        className="btn"
                                        onClick={() => navigate(`/applicant-status/${item.id}`,{
                                          state: {
                                            applicantName: item.firstname
                                          }
                                        })}
                                        style={{
                                          background: 'none',    
                                          border: 'none',       
                                          cursor: 'pointer',   
                                          padding: 0        
                                        }}
                                      >
                                        <AiFillEye style={{ marginRight: '5px',fontSize: '24px' }} />
                                      </button>
                                    </td>
                                    {/* <td className="text-center">
                                      <div className="dropdown wraper_btn">
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            className="btn dropdown-toggle"
                                            variant="success"
                                            id="dropdown-basic"
                                          >
                                            <img
                                              src={dots}
                                              className="img-fulid  "
                                              onClick={() =>
                                                setSelectedApplicant(item.id)
                                              }
                                            />
                                            <span className="caret"></span>
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            as="ul"
                                            className="dropul"
                                          >
                                            <Dropdown.Item
                                              as="li"
                                              to="#/action-2"
                                              onClick={() =>
                                                handleReject(item.id)
                                              }
                                            >
                                              Reject
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              as="li"
                                              to="#/action-2"
                                              onClick={() =>
                                                handleApprove(item.id)
                                              }
                                            >
                                              Approve
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </td> */}
                                  </tr>
                                ))}
                            </>
                          )}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {listAnalyst != 0 ? (pageNumber === pageCountAnalyst - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
                            {listAnalyst} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountAnalyst}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>

                  <Tab
                    onSelect={InProgress}
                    eventKey="Progress"
                    title="Pending"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30  mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Applicant ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Folder Link
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {available
                            .slice(pagesVisited, pagesVisited + usersPerPage)
                            ?.map((item) => (
                              <tr>
                                {/* <td className="pl_25">{item.id} </td> */}
                                <td>
                                  {" "}
                                  {item.firstname} {item.lastname}
                                </td>
                                <td style={{ wordBreak: "break-all" }}>
                                  {item.email}
                                </td>
                                <td>
                                  <button
                                    className="link-button"
                                    onClick={() => openBucketModal(item)}
                                  >
                                    bucket
                                  </button>
                                </td>

                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <div className="btn_Subscribed">
                                      {" "}
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.is_cancelled === 0
                                            ? "them_btn_Pending"
                                            : "them_btn_Unsubscribed")
                                        }
                                      >
                                        {item.is_cancelled === 0
                                          ? "Pending"
                                          : "Cancelled"}
                                      </button>{" "}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="dropdown wraper_btn">
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        className="btn dropdown-toggle"
                                        variant="success"
                                        id="dropdown-basic"
                                      >
                                        <img
                                          src={dots}
                                          className="img-fulid  "
                                        />
                                        <span className="caret"></span>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu as="ul" className="dropul">
                                        <Dropdown.Item
                                          as="li"
                                          to="#/action-2"
                                          onClick={() => handleReject(item.id)}
                                        >
                                          Reject
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          as="li"
                                          to="#/action-2"
                                          onClick={() => handleApprove(item.id)}
                                        >
                                          Approve
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {listAvailable != 0 ? (pageNumber === pageCountAvailable - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
                            {listAvailable} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountAvailable}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="Completed"
                    title="Cancelled"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Applicant ID
                            </th> */}
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Folder Link
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {unavailable
                            .slice(pagesVisited, pagesVisited + usersPerPage)
                            ?.map((item) => (
                              <tr>
                                {/* <td className="pl_25">{item.id} </td> */}
                                <td>
                                  {" "}
                                  {item.firstname} {item.lastname}
                                </td>
                                <td style={{ wordBreak: "break-all" }}>
                                  {item.email}
                                </td>
                                <td>
                                  <button
                                    className="link-button"
                                    onClick={() => openBucketModal(item)}
                                  >
                                    bucket
                                  </button>
                                </td>

                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <div className="btn_Subscribed">
                                      {" "}
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.is_cancelled === 0
                                            ? "them_btn_Pending"
                                            : "them_btn_Unsubscribed")
                                        }
                                      >
                                        {item.is_cancelled === 0
                                          ? "Pending"
                                          : "Cancelled"}
                                      </button>{" "}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="dropdown wraper_btn">
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        className="btn dropdown-toggle"
                                        variant="success"
                                        id="dropdown-basic"
                                      >
                                        <img
                                          src={dots}
                                          className="img-fulid  "
                                        />
                                        <span className="caret"></span>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu as="ul" className="dropul">
                                        <Dropdown.Item
                                          as="li"
                                          to="#/action-2"
                                          onClick={() => handleReject(item.id)}
                                        >
                                          Reject
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          as="li"
                                          to="#/action-2"
                                          onClick={() => handleApprove(item.id)}
                                        >
                                          Approve
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {listUnavailable != 0 ? (pageNumber === pageCountUnavailable - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
                            {listUnavailable} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountUnavailable}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>

              <Modal
                className="starrating"
                show={showModals}
                onHide={handleCloses}
              >
                <Modal.Header>
                  <Modal.Title as="h5">ID: {selectedApplicant.id}</Modal.Title>
                  <div>
                    <img
                      src={shareIcon}
                      alt="Share"
                      className="share_icon_img"
                      onClick={openShareModal}
                    />
                    <button
                      onClick={handleCloses}
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      {" "}
                      <span aria-hidden="true">&times;</span>{" "}
                    </button>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="bucket-info">
                    <div className="bucket-info-inner">
                      <Link
                        to={{
                          pathname: `/bucketVideos/${selectedApplicant.id}`,
                        }}
                      >
                        <img
                          src={folder}
                          alt="Bucket"
                          className="bucket-image"
                        />
                        <p className="bucket-name">bucket name</p>
                      </Link>
                    </div>
                  </div>
                  <div
                    className="modal-footer border-top-0"
                    style={{ padding: "0.5rem" }}
                  >
                    <button
                      onClick={() => handleReject(selectedApplicant.id)}
                      type="button"
                      className=" them_btn_ouline  "
                    >
                      Reject
                    </button>
                    <button
                      onClick={() => handleApprove(selectedApplicant.id)}
                      type="button"
                      className="them_btn1 "
                      data-toggle="modal"
                      data-target="#new_team_add_yes"
                    >
                      {uploadSpin ? <SpinnerCircular /> : "Approve"}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal show={showShareModal} onHide={handleShareClose}>
                <Modal.Header>
                  <Modal.Title>Share Applicants</Modal.Title>
                  <button
                    onClick={handleShareClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <h5>Select Analysts</h5>
                  <table className="table table-borderless table-responsive-md share_modal">
                    <thead>
                      <tr>
                        <th className="pl_25">
                          <label className="check_box">
                            <input
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleHeaderCheckboxChange}
                            />{" "}
                            <span className="checkmark for_modal"></span>{" "}
                          </label>
                        </th>
                        {/* <th scope="col" className="  pl_25">
                          ID
                        </th> */}
                        <th scope="col" className=" ">
                          Analyst Name
                        </th>
                        <th scope="col" className="  text-center">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <div
                          style={{
                            position: "absolute",
                            marginTop: 250,
                            backgroundColor: "#ffffffc2",
                            marginLeft: 580,
                            backgroundBlendMode: "overlay",
                            zIndex: 100,
                          }}
                        >
                          <SpinnerCircular size="15%" />
                        </div>
                      ) : (
                        <>
                          {analystForModal
                            .slice(
                              pagesVisitedModal,
                              pagesVisitedModal + usersPerPageModal
                            )
                            ?.map((item) => (
                              <tr
                                data-id={item.id}
                                style={{ borderTop: "none" }}
                              >
                                <td className="pl_25">
                                  <label className="check_box">
                                    <input
                                      type="checkbox"
                                      checked={checkedEmails.includes(
                                        item.email
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(item.email)
                                      }
                                    />{" "}
                                    <span className="checkmark for_modal"></span>{" "}
                                  </label>
                                </td>
                                {/* <td className="pl_25">{item.id} </td> */}
                                <td>
                                  {" "}
                                  {item.firstname} {item.lastname}
                                </td>
                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <div className="btn_Subscribed">
                                      {" "}
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.is_available === 1
                                            ? "them_btn_Subscribed modal_sub_button"
                                            : "them_btn_Unsubscribed modal_sub_button")
                                        }
                                      >
                                        {item.is_available === 1
                                          ? "Available"
                                          : "UnAvailable"}
                                      </button>{" "}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                  <div className="pagination">
                    <div className="reactPaginate">
                      <ReactPaginate
                        previousLabel={"<<"}
                        nextLabel={">>"}
                        pageCount={pageCountAnalystModal}
                        onPageChange={changePage}
                        containerClassName={
                          "paginationBttns pagination_btn_square"
                        }
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"paginationDisabled"}
                        activeClassName={"paginationActive"}
                      />
                    </div>
                  </div>
                  <div className="modal_footer">
                    <button
                      onClick={handleShareClose}
                      className="btn btn-secondary modal_cancel_btn"
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary modal_send_btn"
                      onClick={handleSendClick}
                    >
                      Send
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>

              {/* Select Analysts Share Modal */}
              <Modal show={showSelectAnalystsModal} onHide={() => setShowSelectAnalystsModal(false)} className="applicant-modal-dialog-centered">
                <Modal.Header>
                  <Modal.Title>{`Share ${selectedApplicantName}'s profile to analysts`}</Modal.Title>
                  <button type="button" className="close" onClick={() => setShowSelectAnalystsModal(false)}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}> {/* Set max height and enable vertical scrolling */}
                  <div>
                    <label>
                      <input
                        id="selectAllCheckbox" // Assign an ID for reference
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={chosenAnalysts.length === analystList.length} // Check if all are selected
                        style={{ marginRight: '10px' }}
                      />
                      Select All
                    </label>
                    <ul>
                      {analystList.map(analyst => (
                        <li key={analyst.id} style={{ marginBottom: '10px' }}>
                          <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                              type="checkbox"
                              checked={chosenAnalysts.includes(analyst.id)}
                              onChange={() => toggleAnalystSelection(analyst.id)}
                              style={{ marginRight: '10px' }} // Space between checkbox and name
                            />
                            {capitalizeName(analyst.firstname)} {capitalizeName(analyst.lastname)} ({analyst.email})
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={onShareClick}
                    type="button"
                    className="them_btn1"
                    disabled={chosenAnalysts.length === 0}
                    style={{
                      opacity: chosenAnalysts.length === 0 ? 0.5 : 1, // Optional: reduce opacity for disabled state
                      cursor: chosenAnalysts.length === 0 ? 'not-allowed' : 'pointer' // Optional: change cursor style
                    }}
                  >
                    Share
                  </button>
                  <button onClick={() => setShowSelectAnalystsModal(false)} type="button" className="them_btn_ouline">
                    Close
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}

export default Applicants;
